import { matchPath } from 'react-router-dom';

import { shellPaths } from '@/core/router/app-paths';
import { isShellObjectIdParam } from '@/core/router/shell-object-id-param';

export const FEEDBACK_INVITE_DETAIL_PATH = `${shellPaths.feedbackInvites}/:inviteId`;

/** Ionic can leave `useParams` stale; fall back to the current pathname. */
export function resolveFeedbackInviteId(
  params: { inviteId?: string },
  pathname: string,
): string | undefined {
  if (isShellObjectIdParam(params.inviteId)) return params.inviteId;
  const matched = matchPath(
    { path: FEEDBACK_INVITE_DETAIL_PATH, end: true },
    pathname,
  );
  const inviteId = matched?.params?.inviteId;
  return isShellObjectIdParam(inviteId) ? inviteId : undefined;
}
